import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import Config from './modules/ckcore/core/Config';
import Dashboard from './modules/dashboard/Dashboard';
import * as serviceWorker from './serviceWorker';
import { ReactKeycloakProvider } from '@react-keycloak/web';
import keycloak from './keycloak';


// DEV CONFIG in server 192.168.1.6:/ckpay/dashboard
Config.setServerURL("https://stg.chuyenkhoan.com/dashboard");
Config.setPaymentServerURL("https://stg.chuyenkhoan.com/pay/v1?");
Config.setCheckoutServerURL("https://stg.chuyenkhoan.com/checkout/v1/ckpay.html?");

// LIVE CONFIG
// // set config URL to dashboard.chuyenkhoan.com
// Config.setServerURL("https://dashboard.chuyenkhoan.com/dashboard?");
// Config.setPaymentServerURL("https://thanhtoan.chuyenkhoan.com/pay/v1?");

const eventLogger = (event, error) => {
    console.log('onKeycloakEvent', event, error);
};
  
const tokenLogger = (tokens) => {
    console.log('onKeycloakTokens', tokens);
};
  
ReactDOM.render(

    <ReactKeycloakProvider
        authClient={keycloak}
        initOptions={{ onLoad: 'login-required' }}
        onEvent={eventLogger}
        onTokens={tokenLogger}
        >
        <Dashboard />
    </ReactKeycloakProvider>
    
    ,document.getElementById('ckdashboard')
);
  

serviceWorker.unregister();
